/**
 * Application Default Values
 * Centralized defaults for both frontend and backend
 * Single source of truth for fallback values
 */

export const DEFAULTS = {
    region: 'california',
    area: 'san-diego-county',
    station: '9410170',
    // Default spot slug for spot-based navigation (must exist in data/spots.json)
    spot: 'ocean-beach-pier',
    hour: 6,
    score: 80
};

// Convenience exports for specific contexts
export const DEFAULT_REGION = DEFAULTS.region;
export const DEFAULT_AREA = DEFAULTS.area;
export const DEFAULT_STATION = DEFAULTS.station;
export const DEFAULT_SPOT = DEFAULTS.spot;
export const DEFAULT_HOUR = DEFAULTS.hour;
export const DEFAULT_SCORE = DEFAULTS.score;

// Default coordinates for San Diego (used as ultimate fallback)
export const DEFAULT_COORDS = {
    lat: 32.7142,
    lon: -117.1736
};

export const DEFAULT_WEATHER_POINT = {
    lat: 32.7157,
    lon: -117.1611
};

export const DEFAULT_MAP_CENTER = {
    lat: 32.79,
    lon: -117.22
};

export const DEFAULT_MAP_ZOOM = 10;
